/**
 * slack_find_user — canonical manifest (zero imports, shared with tool-runtime).
 *
 * Resolves a Slack user ID from a display name or email address.
 * Use this before slack_send_dm when you only know a Contact's name/email
 * and need to derive their Slack user ID.
 */

export const MANIFEST = {
  name: 'slack_find_user',
  description: `Find a Slack user by email address or display name.

**INTEGRATION REQUIRED:** User must connect a Slack workspace in Settings → Integrations first.

**USE CASES:**
- Bridge a Contact's email to their Slack user ID before sending a DM
- Look up a workspace member by display name

**EXAMPLES:**

Find by email:
{ "query": "alice@acme.com" }

Find by name (partial match):
{ "query": "Alice Johnson" }

Find in a specific workspace:
{ "query": "alice@acme.com", "workspaceId": "T012AB3CD" }

**RETURNS:**
{ userId, name, realName, displayName, email, workspaceId }
userId will be null if no match is found.`,
  inputSchema: {
    type: 'object' as const,
    properties: {
      query: {
        type: 'string',
        description: 'Email address or display name to search for',
      },
      workspaceId: {
        type: 'string',
        description: 'Slack team ID (T...) to search in. Omit to use any connected workspace.',
      },
    },
    required: ['query'],
  },
} as const;
